import ApiService from "../ApiService";

const fileLogService = {
  getLog(page, rowsPerPage) {
    return ApiService.customRequest({
      url: `${ApiService.getVademecumUrl()}/upload/?page=${page}&perPage=${rowsPerPage}`,
      method: 'get'
    });
  }
};

export default fileLogService;
